module.exports = __webpack_public_path__ + "assets/ico-check-disponibilidade.3f23aabb.svg";